"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAssignedAgentDto = instanceOfAssignedAgentDto;
exports.AssignedAgentDtoFromJSON = AssignedAgentDtoFromJSON;
exports.AssignedAgentDtoFromJSONTyped = AssignedAgentDtoFromJSONTyped;
exports.AssignedAgentDtoToJSON = AssignedAgentDtoToJSON;
exports.AssignedAgentDtoToJSONTyped = AssignedAgentDtoToJSONTyped;
/**
 * Check if a given object implements the AssignedAgentDto interface.
 */
function instanceOfAssignedAgentDto(value) {
    return true;
}
function AssignedAgentDtoFromJSON(json) {
    return AssignedAgentDtoFromJSONTyped(json, false);
}
function AssignedAgentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}
function AssignedAgentDtoToJSON(json) {
    return AssignedAgentDtoToJSONTyped(json, false);
}
function AssignedAgentDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
    };
}
